import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

import { environment } from 'src/environments/environment';
import { ServiceRequestTypeDynamicNumberInterface } from '../../template/sidebar/interfaces/service-request-type-dynamic-number.interface';

@Injectable({
  providedIn: 'root',
})
export class CustomerSidebarHttpService {
  constructor(private httpClient: HttpClient) {}

  /**
   * get number of customer service requests
   */
  getNumberOfCustomerServiceRequests(): Observable<ServiceRequestTypeDynamicNumberInterface> {
    const url = `${environment.apiUrl}/Customer/GetNumberOfCustomersRequests`;

    return this.httpClient
      .get<ServiceRequestTypeDynamicNumberInterface>(url)
      .pipe(catchError((error: HttpErrorResponse) => throwError(() => error)));
  }

  /**
   * get number of pending customer service requests
   */
  getNumberOfCustomerPendingServiceRequests(): Observable<number> {
    const url = `${environment.apiUrl}/ServiceRequest/GetNumberOfCustomersPendingRequests`;

    return this.httpClient.get<number>(url).pipe(catchError((error: HttpErrorResponse) => throwError(() => error)));
  }
}
